const CARDS = [
  {
    title: '韩国电影年度精选',
    desc: '盘点2026年必看的韩国电影，从犯罪大片到催泪剧情，每一部都不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20film%20collage%20style%2C%20dramatic%20movie%20scene%20with%20warm%20lighting%2C%20urban%20Seoul%20cityscape%20at%20night%2C%20film%20festival%20aesthetic%2C%20rich%20contrast%2C%20golden%20and%20crimson%20tones&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '专题合集',
  },
  {
    title: '宫崎骏动画全收录',
    desc: '从《千与千寻》到《你想活出怎样的人生》，宫崎骏经典动画电影一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20dreamy%20landscape%2C%20Ghibli-inspired%20scenery%2C%20fluffy%20clouds%20and%20green%20hills%2C%20soft%20pastel%20color%20palette%2C%20whimsical%20fantasy%20atmosphere&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '导演专题',
  },
  {
    title: '日韩悬疑烧脑推荐',
    desc: '层层反转的高能悬疑片，每一部都让你看到最后一分钟才恍然大悟。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20film%20noir%20aesthetic%2C%20shadowy%20alleyway%20scene%2C%20rain-slicked%20streets%2C%20venetian%20blind%20shadows%2C%20moody%20atmospheric%20lighting%2C%20detective%20thriller%20vibe&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '类型推荐',
  },
  {
    title: '笑到停不下来的喜剧',
    desc: '精选日韩高分喜剧电影，轻松解压，适合周末宅家一口气刷完。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20Korean%20comedy%20film%20scene%2C%20warm%20sunny%20day%2C%20colorful%20urban%20setting%2C%20happy%20vibrant%20atmosphere%2C%20lighthearted%20cinematic%20style%2C%20soft%20natural%20lighting&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '类型推荐',
  },
  {
    title: '经典老片修复合辑',
    desc: '重温那些年看过的日韩经典老片，高清修复版画质，情怀满分。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20warm%20nostalgic%20tones%2C%20old%20movie%20theater%20interior%2C%20classic%20cinema%20posters%2C%20film%20grain%20texture%2C%20retro%20vintage%20color%20palette%2C%20golden%20hour%20lighting&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '经典回顾',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">精选推荐</h2>
        <p className="text-sm text-foreground-500 mb-8">编辑精选的日韩电影专题合辑，总有一款适合你</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.slice(0, 3).map((card, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer">
              <div className="aspect-[8/5] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
              </div>
              <div className="p-4">
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mt-2 mb-1 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
          {CARDS.slice(3).map((card, i) => (
            <div key={i + 3} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer sm:col-span-2 lg:col-span-3">
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-64 flex-shrink-0 aspect-[8/5] sm:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                </div>
                <div className="p-5 flex flex-col justify-center">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap self-start">
                    {card.tag}
                  </span>
                  <h3 className="font-heading text-lg text-foreground-900 mt-2 mb-1 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}